/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from "react";
import { jsx, css } from "@emotion/react";
import { formatDistanceToNow, format } from "date-fns";
import { TValidCardAttachment, TTargetList } from "../..";
import trelloColors from "../../../../styles/trello-colors";
import { extractTrelloCardShortLink } from "../../../../utils/attachment-link-helper";
import ConditionalRender from "../../../shared/components/conditional-renderer";
import LinkLikeButton from "../../../shared/components/link-like-button";
import Popover from "../../../shared/components/popover/popover";
import PopoverConfirmationContent from "../../../shared/components/popover-confirmation-content";

type TProps = {
  validCard: TValidCardAttachment;
  shortLinkCurrentCard: string;
  onConnectCardsRequest(idTargetCard: string): void;
  onRemoveAttachmentRequest(idAttachment: string): void;
  isWritableByUser: boolean;
};

function AttachedCard(props: TProps) {
  let el: any = null;
  const card = props.validCard.card;

  useEffect(() => {
    if (!el || !el.shadowRoot) {
      return;
    }
    el.card = card;
  }, [el, card]);

  const setRef = (element) => {
    el = element;
  };

  const isBacklinked = card.attachments.some(
    (a) => extractTrelloCardShortLink(a.url) == props.shortLinkCurrentCard
  );

  const cardListType = props.validCard.targetList;

  return (
    <div css={styles.container}>
      {/* @ts-ignore */}
      <trello-card ref={setRef} />
      <div css={styles.data}>
        <div>
          in{" "}
          <span css={[styles.emphasizedText, styles.target(cardListType)]}>
            {card.list?.name}
          </span>
        </div>
        <div>
          modified{" "}
          <span
            title={format(
              new Date(card.dateLastActivity),
              "dd MMM yyyy, HH:mm:ss"
            )}
            css={[styles.emphasizedText, styles.cursorInfo]}
          >
            {formatDistanceToNow(new Date(card.dateLastActivity), {
              addSuffix: true,
            })}
          </span>
        </div>
        <div css={styles.buttonsRow}>
          <ConditionalRender
            condition1={!isBacklinked && props.isWritableByUser}
            renderIf1True={
              <Popover
                trigger={(togglePopover) => (
                  <LinkLikeButton onClick={togglePopover}>
                    Connect cards...
                  </LinkLikeButton>
                )}
                title="Create backlink?"
                isEmbedded={true}
                render={(close) => (
                  <PopoverConfirmationContent
                    confirmationContent={`Would you like to also attach current card to "${card.name}"?`}
                    confirmationContentCss={styles.confirmationContent}
                    confirmationButtonText={"Connect both cards"}
                    confirmationButtonTrelloClass={"mod-primary"}
                    onConfirmationButtonClick={() => {
                      props.onConnectCardsRequest(card.id);
                      close();
                    }}
                  />
                )}
              />
            }
          />
          <Popover
            trigger={(togglePopover) => (
              <LinkLikeButton onClick={togglePopover}>Remove</LinkLikeButton>
            )}
            title="Remove Attachment?"
            isEmbedded={true}
            render={() => (
              <PopoverConfirmationContent
                confirmationContent={`Remove this attachment? There is no undo`}
                confirmationContentCss={styles.confirmationContent}
                confirmationButtonText={"Remove"}
                confirmationButtonTrelloClass={"mod-danger"}
                onConfirmationButtonClick={() => {
                  props.onRemoveAttachmentRequest(props.validCard.idAttachment);
                  close();
                }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default AttachedCard;

const styles = {
  container: css`
    display: flex;
    justify-content: space-between;
  `,
  target: (list: TTargetList) => css`
    color: ${list == "done"
      ? trelloColors["green-600"]
      : list == "wip"
      ? trelloColors["orange-600"]
      : "inherit"};
    font-weight: 600;
  `,
  data: css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    /* width: 200px; */
  `,
  buttonsRow: css`
    display: flex;
    flex-direction: row;
    & > *:not(:first-of-type) {
      margin-left: 8px;
      z-index: 9;
    }
  `,
  emphasizedText: css`
    font-weight: 600;
  `,
  confirmationContent: css`
    text-align: start;
  `,
  cursorInfo: css`
    cursor: help;
  `,
};
